import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Briefcase, UsersThree } from '@phosphor-icons/react';
import { useLayout } from '../../contexts/LayoutContext';
import PropTypes from 'prop-types';

const ConversationItem = ({ conversation }) => {
  const navigate = useNavigate();
  const { activeConversationId, navCollapsed } = useLayout();

  const isActive = activeConversationId === conversation.id;

  const handleClick = () => {
    navigate(`/app/chat/${conversation.id}`);
  };

  const getIcon = () => {
    return conversation.type === 'sales'
      ? <Briefcase weight="light" size={18} />
      : <UsersThree weight="light" size={18} />;
  };

  const truncateTitle = (title, maxLength = 30) => {
    if (!title) return 'Untitled Conversation';
    if (title.length <= maxLength) return title;
    return title.substring(0, maxLength) + '...';
  };

  if (navCollapsed) {
    return (
      <div
        className={`conversation-item collapsed ${isActive ? 'active' : ''}`}
        onClick={handleClick}
        title={conversation.title || 'Untitled Conversation'}
      >
        <span className="conversation-icon">{getIcon()}</span>
      </div>
    );
  }

  return (
    <div
      className={`conversation-item ${isActive ? 'active' : ''}`}
      onClick={handleClick}
      title={conversation.title || 'Untitled Conversation'}
    >
      <div className="conversation-title">
        {truncateTitle(conversation.title)}
      </div>
    </div>
  );
};

ConversationItem.propTypes = {
  conversation: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string,
    type: PropTypes.oneOf(['sales', 'leadership']).isRequired,
    createdAt: PropTypes.string,
    updatedAt: PropTypes.string,
  }).isRequired,
};

export default ConversationItem;
